(function () {
  const TAG_PARAM = 'filter.p.tag';
  const TAG_PREFIX = 'rcf';
  const LEVELS = [
    { key: 'f1', label: 'Filter 1' },
    { key: 'f2', label: 'Filter 2' },
    { key: 'f3', label: 'Filter 3' },
    { key: 'f4', label: 'Filter 4' }
  ];

  function tagValue(levelNum, value) {
    return TAG_PREFIX + levelNum + '|' + value;
  }

  function parseSkuFilterTags(search) {
    const active = {};
    new URLSearchParams(search).getAll(TAG_PARAM).forEach(function (tag) {
      const match = tag.match(/^rcf([1-4])\|(.+)$/);
      if (match) {
        active['f' + match[1]] = decodeURIComponent(match[2].replace(/\+/g, ' '));
      }
    });
    return active;
  }

  function buildFilterUrl(collectionUrl, selections) {
    const url = new URL(collectionUrl, window.location.origin);
    const params = new URLSearchParams(window.location.search);
    const next = new URLSearchParams();

    params.forEach(function (value, key) {
      if (key === TAG_PARAM && value.indexOf(TAG_PREFIX) === 0) return;
      next.append(key, value);
    });

    LEVELS.forEach(function (level, index) {
      const value = selections[level.key];
      if (value) {
        next.append(TAG_PARAM, tagValue(String(index + 1), value));
      }
    });

    url.search = next.toString();
    return url.toString();
  }

  function initRoot(root) {
    if (!root || root.dataset.skuFilterReady === 'true') return;

    const collectionUrl = root.dataset.collectionUrl;
    const treeUrl = root.dataset.treeUrl;
    const fieldsWrap = root.querySelector('[data-sku-filter-fields]');
    const actionsWrap = root.querySelector('[data-sku-filter-actions]');
    const clearLink = root.querySelector('[data-sku-filter-clear]');

    if (!collectionUrl || !treeUrl || !fieldsWrap) return;

    const active = parseSkuFilterTags(window.location.search);
    const selects = {};

    LEVELS.forEach(function (level) {
      const field = document.createElement('div');
      field.className = 'sku-hierarchy-filter__field';

      const label = document.createElement('label');
      label.textContent = level.label;
      label.setAttribute('for', 'sku-filter-' + level.key + '-' + root.dataset.index);

      const select = document.createElement('select');
      select.id = 'sku-filter-' + level.key + '-' + root.dataset.index;
      select.dataset.level = level.key;
      select.disabled = level.key !== 'f1';
      select.innerHTML = '<option value="">All</option>';

      field.appendChild(label);
      field.appendChild(select);
      fieldsWrap.appendChild(field);
      selects[level.key] = select;
    });

    function optionsFromObject(obj) {
      return Object.keys(obj || {}).sort(function (a, b) {
        return a.localeCompare(b);
      });
    }

    function resetSelect(levelKey, disabled) {
      const select = selects[levelKey];
      select.innerHTML = '<option value="">All</option>';
      select.value = '';
      select.disabled = !!disabled;
    }

    function fillSelect(levelKey, options, selectedValue) {
      const select = selects[levelKey];
      resetSelect(levelKey, false);
      options.forEach(function (option) {
        const el = document.createElement('option');
        el.value = option;
        el.textContent = option;
        if (selectedValue === option) el.selected = true;
        select.appendChild(el);
      });
      select.disabled = options.length === 0;
    }

    function cascadeFrom(levelKey) {
      const tree = root.__skuFilterTree || {};
      const f1 = selects.f1.value;
      const f2 = selects.f2.value;
      const f3 = selects.f3.value;

      if (levelKey === 'f1') {
        resetSelect('f2', true);
        resetSelect('f3', true);
        resetSelect('f4', true);
        if (f1 && tree[f1]) fillSelect('f2', optionsFromObject(tree[f1]), '');
        return;
      }

      if (levelKey === 'f2') {
        resetSelect('f3', true);
        resetSelect('f4', true);
        if (f1 && f2 && tree[f1] && tree[f1][f2]) {
          fillSelect('f3', optionsFromObject(tree[f1][f2]), '');
        }
        return;
      }

      if (levelKey === 'f3') {
        resetSelect('f4', true);
        if (f1 && f2 && f3 && tree[f1] && tree[f1][f2] && tree[f1][f2][f3]) {
          fillSelect('f4', tree[f1][f2][f3], '');
        }
      }
    }

    function currentSelections() {
      const selections = {};
      LEVELS.forEach(function (level) {
        if (selects[level.key].value) {
          selections[level.key] = selects[level.key].value;
        }
      });
      return selections;
    }

    function updateClearVisibility() {
      const hasActive = Object.keys(parseSkuFilterTags(window.location.search)).length > 0;
      if (actionsWrap) {
        actionsWrap.hidden = !hasActive;
      }
    }

    function applySelectionsFromActive() {
      const tree = root.__skuFilterTree || {};
      fillSelect('f1', optionsFromObject(tree), active.f1 || '');

      if (active.f1 && tree[active.f1]) {
        cascadeFrom('f1');
        fillSelect('f2', optionsFromObject(tree[active.f1]), active.f2 || '');
      }

      if (active.f2 && active.f1 && tree[active.f1] && tree[active.f1][active.f2]) {
        cascadeFrom('f2');
        fillSelect('f3', optionsFromObject(tree[active.f1][active.f2]), active.f3 || '');
      }

      if (active.f3 && active.f1 && active.f2 && tree[active.f1] && tree[active.f1][active.f2] && tree[active.f1][active.f2][active.f3]) {
        cascadeFrom('f3');
        fillSelect('f4', tree[active.f1][active.f2][active.f3], active.f4 || '');
      }

      updateClearVisibility();
    }

    function navigateWithCurrentSelections() {
      window.location.href = buildFilterUrl(collectionUrl, currentSelections());
    }

    LEVELS.forEach(function (level) {
      selects[level.key].addEventListener('change', function () {
        cascadeFrom(level.key);
        navigateWithCurrentSelections();
      });
    });

    fetch(treeUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load filter tree');
        return res.json();
      })
      .then(function (data) {
        root.__skuFilterTree = data.tree || {};
        applySelectionsFromActive();
        root.dataset.skuFilterReady = 'true';
      })
      .catch(function () {
        fieldsWrap.innerHTML = '<p class="sku-hierarchy-filter__error">Unable to load product type filters.</p>';
      });
  }

  function initAll() {
    document.querySelectorAll('[data-sku-filter-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
